import { render, staticRenderFns } from "./Company_formations.vue?vue&type=template&id=205396f0&scoped=true&lang=pug&"
import script from "./Company_formations.vue?vue&type=script&lang=coffee&"
export * from "./Company_formations.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205396f0",
  null
  
)

export default component.exports